import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuthContext } from "./hooks/useAuthContext";
import NewHome from "./pages/NewHome";
import NewSignup from './pages/NewSignup';
import NewLogin from './pages/NewLogin';
import NewDash from "./pages/NewDash";
import NewClients from "./pages/NewClients";
import NewCreateClient from "./pages/NewCreateClient";
import NewClientDetails from "./pages/NewClientDetails";
import NewQuotes from './pages/NewQuotes';
import NewInvoices from './pages/NewInvoices';
import NewCreateQuote from './pages/NewCreateQuote';
import NewQuoteDetails from "./pages/NewQuoteDetails";
import NewCreateInvoice from "./pages/NewCreateInvoice";
import NewInvoiceDetails from "./pages/NewInvoiceDetails";


function App() {

  // checking the state of the user via authcontext
  const {user} = useAuthContext();
  return (
    <div className="App">
      <BrowserRouter>
      <Routes>
        <Route exact path="/" element={!user ? <NewHome/>: <Navigate to="/dashboard"/>}/>
        <Route path="/signup" element={!user ? <NewSignup/>: <Navigate to="/dashboard"/>}/>
        <Route path="/login" element={!user ? <NewLogin/>: <Navigate to="/dashboard"/>}/>
        <Route path="/dashboard" element={user ? <NewDash/> : <Navigate to="/"/>}/>
        <Route path="/clients" element={user ? <NewClients/> : <Navigate to="/"/>}/>
        <Route path="/quotes" element={user ? <NewQuotes/> : <Navigate to="/"/>}/>
        <Route path="/invoices" element={user ? <NewInvoices/> : <Navigate to="/"/>}/>
        <Route path="/client/:clientId" element={user ? <NewClientDetails/> : <Navigate to="/"/>}/>
        <Route path="/invoice/:invoiceId" element={user ? <NewInvoiceDetails/> : <Navigate to="/"/>}/>
        <Route path="/quote/:quoteId" element={user ? <NewQuoteDetails/> : <Navigate to="/"/>}/>
        <Route path="/createclient" element={user ? <NewCreateClient/> : <Navigate to="/"/>}></Route>
        <Route path="/createinvoice" element={user ? <NewCreateInvoice/> : <Navigate to="/"/>}/>
        <Route path="/createquote" element={user ? <NewCreateQuote/> : <Navigate to="/"/>}/>
      </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
